<template>
  <div :class="{'vertical': vertical}">
    <div class="stack">
      <!--Member Avatars-->
      <div class="content" v-for="(member, index) in members.length > showCount ? deductedMembers : members" :key="index" @click="$emit('memberClicked', member)">
        <div class="nameplate">
          <span class="name">
            {{ member.name }}
          </span>
          <div class="triangle-down"></div>
        </div>
        <img :src="member.img" class="img" :class="[size]">
      </div>

      <!--More Indicator-->
      <div v-if="members.length > 3" ref="indicator" class="more-indicator" :class="[size, {'more-indicator-tiny' : members.length > 102}]" @mouseenter="showDropdown">
         +{{ members.length - 3 }}
      </div>
      
      <!--More Members Dropdown-->
      <div v-if="members.length > 3" ref="dropdown" class="more-dropdown-wrapper" >
        <div v-show="dropdown" class="more-dropdown" :class="[size]">
          <!--Search Field-->
          <div v-if="canSearch" class="search-field">
            <input v-model="search" placeholder="Search Team Member" class="search-bar mb-2" @focus="dropdown=true" @blur="dropdown=false"/>
            <span class="fal fa-search search-icon"></span>
          </div>
          <!--List of More Members--> 
          <div class="list">
            <div class="list-content" v-for="(member, index) in filteredList" :key="index" @click="$emit('memberClicked', member)"> 
              <img :src="member.img" class="list-img" :class="[size]">
              <span class="list-name" :class="[size]">{{ member.name }}</span>
            </div>
          </div>
        </div>
      </div>
      
      <!--Add Icon-->
      <div v-if="canAdd" class="add-more" :class="[size]" @click="$emit('addMore')">
        <Icon :icon="['fal', 'user-plus']" fixed-width class="add-icon" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      search: '',
      dropdown: false,
    }
  },
  props: {
    size: {
      required: false,
      type: String,
      default: 'md'
    },
    canAdd: {
      required: false,
      type: Boolean,
      default: false
    },
    canSearch: {
      required: false,
      type: Boolean,
      default: false
    },
    members: {
      required: true,
      type: Array,
    },
    vertical: {
      required: false,
      type: Boolean,
      default: false
    },
    showCount: {
      required: false,
      type: [String, Number],
      default: 3
    }
  },
  computed: {
    deductedMembers () {
      return this.members.slice(0, 3)
    },
    filteredList() {
      //Searches through all array keys
      return this.members.slice(3, this.members.length).filter(members =>
        Object.keys(members).some((key) => {
          return String(members[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1
        })
      )
    }
  },
  methods: {
    showDropdown(){
      this.dropdown = !this.dropdown 
      this.$refs.dropdown.classList.add('show-dropdown')
    },
    clickOutside() {
      this.dropdown = false
      this.search = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.stack {
  display: flex;
  align-items: center;
  .content {
    position: relative;
    display: flex;
    justify-content: center;
    margin-left: -.5rem;
    &:first-child {
      margin-left: 0;
    }
    .img {
      border-radius: 50%;
      object-fit: cover;
      border: 2px solid #ffffff;
      &.sm {
        width: 24px;
        height: 24px;
      }
      &.md {
        width: 32px;
        height: 32px;
      }
      &.lg {
        width: 40px;
        height: 40px;
      }
      &:hover {
        border: 2px solid var(--primary);
        z-index: 10;
      }
    }
    .nameplate {
      display: none;
      justify-content: center;
      position: absolute;
      top: -32px;
      padding: .25rem .75rem;
      background-color: #1e272e;
      border-radius: 5px;
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
      .name {
        font-size: 11px;
        color: #FFF;
        white-space: nowrap;
      }
      .triangle-down {
        position: absolute;
        top: 22px;
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-top: 7px solid #1e272e;
      }
    }
    &:hover {
      .nameplate {
        display: flex;
      }
    }
  }
  .add-more {
    position: relative;
    display: flex;
    justify-content: center;
    cursor: pointer;
    margin-left: 0.15rem;
    border-radius: 50%;
    object-fit: cover;
    border: 1px dashed var(--gray-500);
    background-color: var(--gray-100);
    color: var(--gray-500);  
    .add-icon {
      font-size: 14px;
      font-weight: 700;
      opacity: .65;
    }
    &.sm {
      width: 24px;
      height: 24px;
    }
    &.md {
      width: 32px;
      height: 32px;
    }
    &.lg {
      width: 40px;
      height: 40px;
    }
    &:hover {
      background-color: var(--gray-200);
      .add-icon {
        opacity: 1;
      }
    }
  }
  .more-indicator {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin-left: -.5rem;
    border-radius: 50%;
    object-fit: cover;
    border: 1px solid var(--primary);
    background-color:#DBE6FD;
    color: var(--primary);
    &.sm {
      width: 24px;
      height: 24px;
      font-size: 10px;
    }
    &.md {
      width: 32px;
      height: 32px;
      font-size: 12px;
    }
    &.lg {
      width: 40px;
      height: 40px;
      font-size: 16px;
    }
    &:hover {
      background-color: var(--primary);
      color: #ffffff;
    }
  }
  .more-indicator-tiny{
    font-size: 9.5px!important;
  }
  .more-indicator-active{
    background-color: var(--primary);
    color: #ffffff;
  }
  .more-dropdown{
    position: absolute;
    top: -25px;
    left: 0px;
    z-index: 99;
    padding-left: 0.5rem;
    padding-right: 0.2rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    border-radius: 4px;
    width: max-content;
    background-color: white;
    box-shadow: 0px 8px 18px rgba(0, 0, 0, 0.15), 0px 0px 2px rgba(0, 0, 0, 0.15), 0px 0px 1px rgba(0, 0, 0, 0.15);
    text-align: left;  
    &.sm {
      top: -20px;
    }      
  }
}

//Dropdown Wrapper
.more-dropdown-wrapper{
  position: relative;
  width: 0;
  height: 0;
  display: none;
}
.show-dropdown{
  display: inline;
}

//Dropdown Search Field
.search-field{
  position: relative;
  margin-right: 0.3rem;
}
.search-icon{
  position: absolute;
  top: 9px;
  left: 8px;
  font-size: 15px;
  color: #9CA0B1;
}
.search-bar{
  width: 100%;
  height: 32px;
  border-radius: 3px;
  border: 1px solid #BDC1CC;
  padding-left: 29px;
}
.search-bar::placeholder { 
  color: #BDC1CC;
}
.search-bar:focus {     
  outline: none;
}

//Dropdown List
.list{
  height: max-content;
  max-height: 190px;
  overflow-y: auto; 
}
.list::-webkit-scrollbar {
  width: 6px;
  margin-left: 20px;
}
.list::-webkit-scrollbar-track {
  background: none;
}
.list::-webkit-scrollbar-thumb {
  background: #D8DBE2;
  border-radius: 10px;
}
  
//Dropdown Items
.list-content {
  position: relative;
  display: flex;
  align-items: center;
  padding-top: 3px;
  padding-bottom: 3px;
  .list-img {
    border-radius: 50%;
    object-fit: cover;
    border: 2px solid #ffffff;
    margin-right: 5px;
    &.sm {
      width: 24px;
      height: 24px;
    } 
    &.md {
      width: 32px;
      height: 32px;
    }
    &.lg {
      width: 40px;
      height: 40px;
    }
  }
  .list-name {
    white-space: nowrap;
    margin-right: 1.5rem;
    &.sm {
      font-size: 11px;
    } 
    &.md {
      font-size: 13px;
    }
    &.lg {
      font-size: 14px;
    }
  }
}

//Vertical Layout
.vertical {
  .stack {
    display: inline-flex;
    flex-direction: column;
    .content {
      margin-top: -.5rem;
      margin-left: 0;
      &:first-child {
        margin-top: 0;
      }
    }
    .add-more {
      margin-left: 0;
      margin-top: -.5rem;
    }
    .more-indicator {
      margin-left: 0;
    }
    .more-dropdown{
      top: -35px;
      left: 20px;
    }
  }
}
</style>